import React, { useState } from "react";

export type ColorGroup =
  | {
      group: string;
      description?: string[];
      types?: Array<{
        type: string;
        colors: Array<{ name: string; var: string; hex: string }>;
      }>;
      colors?: never;
    }
  | {
      group: string;
      description?: string[];
      colors: Array<{ name: string; var: string; hex: string }>;
      types?: never;
    };

export interface ShowGroupColorsProps {
  colorGroup: ColorGroup;
  gridColsClass?: string;
}

const ShowGroupColors: React.FC<ShowGroupColorsProps> = ({
  colorGroup,
  gridColsClass = "md:grid-cols-2",
}) => {
  const [toast, setToast] = useState<string | null>(null);

  const handleCopy = (hex: string) => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(hex);
      setToast("Copied!");
      setTimeout(() => setToast(null), 1200);
    }
  };

  return (
    <div className="space-y-12 w-full relative">
      {toast && (
        <div className="fixed left-1/2 top-8 z-50 -translate-x-1/2 bg-primary text-white px-4 py-2 rounded shadow font-bold animate-fade-in">
          {toast}
        </div>
      )}
      <div key={colorGroup.group}>
        <h2 className="text-2xl font-bold text-tx-dark mb-4">
          {colorGroup.group}
        </h2>

        {/* Description */}
        {colorGroup.description && (
          <ul className="text-tx-default mb-10 list-disc list-inside ">
            {colorGroup.description.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
        {colorGroup.types ? (
          <div className={`w-full grid grid-cols-1 ${gridColsClass} gap-4`}>
            {colorGroup.types.map((type) => (
              <div
                key={type.type}
                className="bg-white rounded-lg p-4 border border-bd-overlay"
              >
                <h3 className="text-lg font-extrabold uppercase  text-tx-dark pb-2 mb-4 border-b border-bd-base">
                  {type.type}
                </h3>

                <div className="flex flex-row gap-6">
                  {type.colors.map((color) => (
                    <div
                      key={color.name}
                      className="flex flex-col items-center w-40"
                    >
                      <div
                        className="w-14 h-14 rounded-lg"
                        style={{ background: `var(${color.var})` }}
                      ></div>
                      <div className="mt-2 text-sm font-mono text-tx-muted">
                        {color.name}
                      </div>
                      <div
                        className="text-xs text-tx-dark font-bold uppercase cursor-pointer select-none hover:underline"
                        title="Click to copy"
                        onClick={() => handleCopy(color.hex)}
                      >
                        {color.hex}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : colorGroup.colors ? (
          <div className="bg-white rounded-lg p-4 border border-bd-overlay">
            <div className="flex flex-row gap-6">
              {colorGroup.colors.map((color) => (
                <div
                  key={color.name}
                  className="flex flex-col items-center w-32"
                >
                  <div
                    className="w-14 h-14 rounded-lg"
                    style={{ background: `var(${color.var})` }}
                  ></div>
                  <div className="mt-2 text-sm font-mono text-tx-dark">
                    {color.name}
                  </div>
                  <div
                    className="text-xs text-tx-muted cursor-pointer select-none hover:underline"
                    title="Click to copy"
                    onClick={() => handleCopy(color.hex)}
                  >
                    {color.hex}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ShowGroupColors;
